import { forwardRef } from 'react';
import * as StyledSwitch from './styled/switch';

export type SwitchProps = StyledSwitch.RootProps;

export const Switch = forwardRef<HTMLLabelElement, SwitchProps>(
  (props, ref) => {
    const { children, ...rootProps } = props;

    return (
      <StyledSwitch.Root
        ref={ref}
        {...rootProps}
        opacity={rootProps.disabled ? 0.5 : 1}
      >
        <StyledSwitch.Control>
          <StyledSwitch.Thumb />
        </StyledSwitch.Control>
        {children && <StyledSwitch.Label>{children}</StyledSwitch.Label>}
        <StyledSwitch.HiddenInput />
      </StyledSwitch.Root>
    );
  },
);

Switch.displayName = 'Switch';
